import React from 'react';
import {BigButtonTool} from "../../../toolsSpace/oneLineToolSpace";
import storyResourceImportIcon from "./storyResource.png";
import BaseComponent from "../../../../../base/BaseComponent";
import {Modal, Button, Empty, notification, message} from 'antd';
import UploadWall from "../../../../../components/upload/UploadWall";
import {
    AUDIO_TYPE,
    AUDIO_TYPE_STR,
    PIC_PDF_STR,
    PIC_TYPE,
    VIDEO_TYPE,
    VIDEO_TYPE_ORIGINAL,
    VIDEO_TYPE_STR
} from "../../../../../constants";
import ChunkUpload from "../../../../../components/upload/ChunkUpload";
import {buildInsertPicHtml} from "../../../toolsSpace/tools/pictureTool/pictureTool";
import {buildInsertVideoHtml} from "../../../toolsSpace/tools/videoTool/videoTool";
import {buildInsertAudioHtml} from "../../../toolsSpace/tools/audioTool/audioTool";
import {Scrollbars} from "react-custom-scrollbars";

class StoryResource extends BaseComponent {

    constructor(props) {
        super(props);
        this.state = {
            fileList:[],
            storyResourceModalVisible: false,
            newPicType:['jpg','jpeg', 'gif', 'png', 'bmp'],
        };
        if(this.props.dynamicParams.editorId) {
            this.loadStoryResourceMd5s(this.props.dynamicParams.editorId);
        } else if(this.props.dynamicParams.oldId) {
            this.loadStoryResourceMd5s(this.props.dynamicParams.oldId, (fileList)=>{
                window.ueditor.addAfterSaveDataFun(async (activiti, data, call)=>{
                    return new Promise(((resolve, reject) => {
                        this.saveStoryResourceMd5(data.id, this.convertMd5s(fileList));
                    }));
                });
            });
        }
    }

    loadStoryResourceMd5s(entityId, call){
        if(entityId <= 0){
            return;
        }
        this.request({
            url : "/cm-sites-pms/ueditor/getResources",
            body:{entityId},
            callBack: (data)=>{
                if(data){
                    let {md5s} = data;
                    this.loadStoryResourceInfo(md5s, call);
                }
            }
        })
    }

    convertMd5s = (storyResources)=>{
        let md5s = [];
        storyResources && storyResources.map(item=>{
            if(item.ajaxResult){
                md5s.push(item.ajaxResult.md5);
            }else{
                if(item.originFileObj.name){
                    notification.error({
                        message: `${item.originFileObj.name}文件未能上传成功`
                    })
                }
            }
        });
        return md5s;
    };

    saveStoryResourceMd5 = (storyId, md5s)=>{
        this.request({
            url:"/cm-sites-pms/ueditor/resources",
            method:"post",
            contentType:"json",
            body:{
                entityId : storyId, md5s
            },
        })
    };

    loadStoryResourceInfo(md5s, call){
        if(!(md5s instanceof Array) || md5s.length <= 0){
            return;
        }
        this.request({
            url : "/storage/getStorageFileList",
            body:{md5s: md5s.join(",")},
            callBack: (arr)=>{
                arr && arr.map(file=>{
                    file.url = file.path;
                    file.stateStr = "完成";
                    file.percent = 100;
                    file.ajaxResult = {md5: file.md5};
                    file.originFileObj = {name:file.name};
                    file.response = {path : file.path, thumbnailsPlayPath:file.thumbnailsPlayPath};
                    this.state.fileList.push(file);
                });
                call && call(this.state.fileList);
                this.setState({});
            }
        })
    }

    onChange = (info)=>{
        info.fileList = info.fileList.map(item => {
            // 取决于需要什么数据填入fileList
            if (item.uid === info.file.uid) {
                item.ajaxResult = info.file.response;
                if(info.file.response && info.file.response.data){
                    //分片上传是走的自己封装的接口 所以返回值只有data
                    //直接上传走的是antd的接口，所以返回值还有一个data属性包裹着的。这里主要是兼容两种返回值
                    item.ajaxResult = info.file.response.data;
                    info.file.response = {...info.file.response.data, ...info.file.response};
                    item.response = info.file.response;
                }
                item.uid = info.file.uid;
                item.ext = info.file.response && info.file.response.suffix;
                item.url = info.file.response && info.file.response.path;
                if(info.file.response){
                    if(VIDEO_TYPE.indexOf(info.file.response.suffix)!==-1){
                        item.url = info.file.response.smallThumbnailsPath;
                        item.playPath =  info.file.response.mp4Path
                    }
                }
                item.name = info.file.response && info.file.response.name;
                // item.type = "picture";
                item.isChunk = true;
                item.status = info.file.status;
                item = {...item.ajaxResult, ...item};
            }
            return item;
        });
        this.setState({
            fileList: info.fileList
        })
    };
    handleRemove = (file)=>{
        this.state.fileList = this.state.fileList.filter(item=>item._id!=file._id);
        this.setState({})
    };
    handlePreview = ()=>{};

    beforeUpload = async file => {
        let newPicTypeList = [...this.state.newPicType,...this.state.newPicType.toUpperCase()]
        let data = VIDEO_TYPE.find(item => file.name.endsWith(item)) || newPicTypeList.find(item => file.name.endsWith(item));
        return new Promise((resolve, reject) => {
            let status = this.state.fileList.some(item => item.originFileObj.name === file.name && item.originFileObj.size === file.size);
            if (status) {
                message.destroy();
                message.error('文件已存在！');
                reject()
            }
            if (data) {
                resolve()
            } else {
                message.error(`文件格式不正确！`);
                reject();
            }
        });
    };

    render() {
        return (
            <div>
                <BigButtonTool float={this.props.float}
                               onClick={()=>{
                                   this.setState({storyResourceModalVisible:true})
                               }}
                               style={this.props.style} src={storyResourceImportIcon} text={"稿件资源"} imgWidth={this.props.width} />
                <Modal
                    title={"稿件资源"}
                    width={888}
                    bodyStyle={{maxHeight:550,overflow:"hidden"}}
                    visible={this.state.storyResourceModalVisible}
                    maskClosable={false}
                    keyboard={false}
                    onCancel={()=>{this.setState({storyResourceModalVisible:false})}}
                    footer={<div><Button type={"primary"} size={"default"} onClick={()=>{
                        console.log("this.uploadBtn:         ------------", this.uploadBtn);
                        if(this.uploadBtn){
                            this.uploadBtn.uploadDisplayBtnClick();
                        }
                    }}>上传文件</Button>
                        <Button type={"primary"} size={"default"} onClick={()=>{
                            window.ueditor.addAfterSaveDataFun(async (activiti, data, call)=>{
                                return new Promise(((resolve, reject) => {
                                    this.saveStoryResourceMd5(data.id, this.convertMd5s(this.state.fileList));
                                }));
                            });
                            this.setState({storyResourceModalVisible:false});
                        }} >确定</Button>
                    </div>}
                >
                    <Scrollbars autoHeight autoHeightMax={500}>
                        <UploadWall
                            ref={(uploadBtn)=>{this.uploadBtn = uploadBtn}}
                            accept={"."+[...VIDEO_TYPE_ORIGINAL,...this.state.newPicType].join(",.")}
                            multiple={true}
                            action="/storage/uploadFile"
                            listType={"infoCard"}
                            showUploadBtn={false}
                            style={{padding:0}}
                            insertCall={(file)=>{
                                if(AUDIO_TYPE.indexOf(file.suffix) !== -1){
                                    // this.props.editor.execCommand("inserthtml", buildInsertAudioHtml(file.url));
                                }else if(PIC_TYPE.indexOf(file.suffix) !== -1){
                                    // width:null,height:null,  这里给null是因为buildInsertPicHtml方法内部给了默认值
                                    let isSuccess = this.props.editor.rmtExecCommand("inserthtml", buildInsertPicHtml({...file, width:null,height:null, title:file.name,sourceUrl:file.url}));
                                }else if(VIDEO_TYPE.indexOf(file.suffix) !== -1){
                                    // width:null,height:null,  这里给null是因为buildInsertVideoHtml方法内部给了默认值
                                    let isSuccess = this.props.editor.rmtExecCommand("inserthtml", buildInsertVideoHtml({...file,width:null,height:null, path:file.mp4Path,playUrl:file.thumbnailsPlayPath,videoPic:file.thumbnailsPath, title:file.name,url:file.mp4Path}));
                                }
                            }}
                            showUploadDisplayBtn={true}
                            fileList={this.state.fileList}
                            customRequest={new ChunkUpload({
                                checkFileURL:"/storage/checkFile",
                                checkChunkURL:"/storage/checkChunk",
                                uploadChunkURL:"/storage/uploadChunk",
                                chunkUploadOverURL:"/storage/chunkIsUploadOver",
                                mergeChunksURL:"/storage/mergeChunk"
                            }).start}
                            icons={["eye", "download", "delete"]}
                            uploadBtnName={"点击上传"}
                            onChange={this.onChange}
                            onRemove={this.handleRemove}
                            onPreview={this.handlePreview}
                            beforeUpload={this.beforeUpload}
                        />
                        {(!this.state.fileList || this.state.fileList.length === 0) && <Empty/>}
                    </Scrollbars>
                </Modal>
            </div>
        );
    }
}

export default StoryResource;